import React from "react";
import {Link} from "react-router-dom";
import {Spinner} from "react-bootstrap";

import "./Button.css";

const VARIANT_CLASS = {
    primary: "nco-btn-primary",
    secondary: "nco-btn-ghost",
    soft: "nco-btn-soft",
    danger: "nco-btn-danger",
    link: "ui-btn-link",
};

// `href` renders an <a>, `to` a router <Link>; a disabled or loading link falls back to a disabled <button>.
// `selected` marks a toggle: sets aria-pressed and shows the primary look while true.
export default function Button({
    ref,
    variant = "secondary",
    size = "sm",
    icon = null,
    loading = false,
    fullWidth = false,
    selected,
    href,
    to,
    type = "button",
    disabled = false,
    className = "",
    children,
    ...rest
}) {
    const classes = [
        "nco-btn",
        "ui-btn",
        VARIANT_CLASS[selected ? "primary" : variant] ?? VARIANT_CLASS.secondary,
        size === "md" ? "ui-btn-md" : "nco-btn-sm",
        fullWidth && "ui-btn-full",
        loading && "ui-btn-loading",
        selected && "ui-btn-selected",
        className,
    ].filter(Boolean).join(" ");

    const content = (
        <>
            <span className="ui-btn-label">
                {icon && <span className="ui-btn-icon" aria-hidden="true">{icon}</span>}
                {children}
            </span>
            {loading && (
                <span className="ui-btn-spinner">
                    <Spinner animation="border" size="sm" role="status"/>
                </span>
            )}
        </>
    );

    if ((href != null || to != null) && !disabled && !loading) {
        const Tag = to != null ? Link : "a";
        return (
            <Tag ref={ref} className={classes} {...(to != null ? {to} : {href})} {...rest}>
                {content}
            </Tag>
        );
    }

    return (
        <button
            ref={ref}
            type={type}
            className={classes}
            disabled={disabled || loading}
            aria-busy={loading || undefined}
            aria-pressed={typeof selected === "boolean" ? selected : undefined}
            {...rest}
        >
            {content}
        </button>
    );
}
